import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { postApi } from 'redux/apis';

// Get Transactions
export const getTransactionsAction = createAsyncThunk(
    'transactions/getTransactions',
    async (params: any = {}, { rejectWithValue }) => {
        try {
            const { signal, ...restParams } = params;
            const response = await postApi('/transactions', {
                ...restParams,
                companyId: localStorage.getItem('companyId'),
            }, false, undefined, signal);
            return response.data.data;
        } catch (error: any) {
            if (axios.isCancel(error) || error?.name === 'CanceledError') {
                return rejectWithValue({ cancelled: true });
            }
            if (!error.response) {
                throw error;
            }
            return rejectWithValue(error?.response?.data);
        }
    }
);

// Sync Transactions
export const syncTransactionsAction = createAsyncThunk(
    'transactions/syncTransactions',
    async (params: any = {}, { rejectWithValue }) => {
        try {
            const response = await postApi('/transactions/sync-transactions', {
                companyId: localStorage.getItem('companyId'),
                fromDate: params.fromDate,
                toDate: params.toDate,
            });
            return response.data;
        } catch (error: any) {
            if (!error.response) {
                throw error;
            }
            return rejectWithValue(error?.response?.data);
        }
    }
);

// Batch Edit Transactions
export const batchEditTransactionsAction = createAsyncThunk(
    'transactions/batchEditTransactions',
    async (params: any = {}, { rejectWithValue }) => {
        try {
            const response = await postApi('/transactions/batch-edit-transactions', {
                companyId: localStorage.getItem('companyId'),
                txnLineIds: params.txnLineIds || [],
                accountRef: params.accountRef,
                customerRef: params.customerRef,
                classRef: params.classRef,
                locationRef: params.locationRef,
                fromDate: params.fromDate,
                toDate: params.toDate,
                editAll: params.editAll,
                // Include filter parameters when editAll is true
                accountIds: params.editAll ? params.accountIds : undefined,
                customerIds: params.editAll ? params.customerIds : undefined,
                classIds: params.editAll ? params.classIds : undefined,
                locationIds: params.editAll ? params.locationIds : undefined,
                entityTypes: params.editAll ? params.entityTypes : undefined,
                lineBasedOn: params.editAll ? params.lineBasedOn : undefined,
                vendorIds: params.editAll ? params.vendorIds : undefined,
            });
            return response.data;
        } catch (error: any) {
            if (!error.response) {
                throw error;
            }
            return rejectWithValue(error?.response?.data);
        }
    }
);

// Update Single Transaction Line Item
export const updateTransactionLineItemAction = createAsyncThunk(
    'transactions/updateTransactionLineItem',
    async (params: {
        txnId: string;
        lineId: string;
        entityType: string;
        accountRef?: { value: string; name: string };
        customerRef?: { value: string; name: string; isProject?: boolean };
        classRef?: { value: string; name: string };
        locationRef?: { value: string; name: string };
        accountIds?: string[];
        customerIds?: string[];
        classIds?: string[];
        locationIds?: string[];
    }, { rejectWithValue }) => {
        try {
            const response = await postApi('/transactions/update-transaction-line-item', {
                companyId: localStorage.getItem('companyId'),
                txnId: params.txnId,
                lineId: params.lineId,
                entityType: params.entityType,
                accountRef: params.accountRef,
                customerRef: params.customerRef,
                classRef: params.classRef,
                locationRef: params.locationRef,
            });
            return response.data;
        } catch (error: any) {
            if (!error.response) {
                throw error;
            }
            return rejectWithValue(error?.response?.data);
        }
    }
);